import React, { useState, useEffect } from "react";
import { SearchBar } from "../components/Person Recognition/searchBox";
import { ResultCrad } from "../components/Person Recognition/resultCards";
import authAxios from "../keycloak/authAxios";

export const LostPeople = () => {
  const [results, setResults] = useState([]);

  // on First Render/Mount only!
  useEffect(() => {
    var API_URL = `arshad?&flag=LOST&timestamp=${new Date().getTime()}`;

    const fetchData = async () => {
      const res = await authAxios.get(API_URL);
      setResults(res.data.result);
    };

    fetchData();
  }, []);

  return (
    <>
      <SearchBar
        flag="LOST"
        onSearch={(value) => {
          setResults(value);
        }}
      />

      <div style={{ marginTop: 30 }} align="center">
        <ResultCrad foundPersonResult={results} />
      </div>
    </>
  );
};
